import { render, staticRenderFns } from "./CentroCustoManage.vue?vue&type=template&id=231e8963&scoped=true"
import script from "./CentroCustoManage.vue?vue&type=script&lang=js"
export * from "./CentroCustoManage.vue?vue&type=script&lang=js"
import style0 from "./CentroCustoManage.vue?vue&type=style&index=0&id=231e8963&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e8963",
  null
  
)

export default component.exports